<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="!currentItem">
    Loading...
  </div>
  <div class="main-page-content-block p-2 " *ngIf="currentItem">
    <div class="row">
      <div class="col-12">
        <div class="float-right font-22 d-flex pl-2">
          <div class="d-inline ml-1 pl-1 mt-2 pt-1 bg-white" role="button" title="Mark Critical" (click)="doSetCritical()">
            <i class="m-0 p-0 fa fa-flag" [ngClass]="{ 'txt-red': currentItem.IsCritical }"></i>
          </div>
          <!-- <div class="d-inline ticket-view-btn text-center ml-3"
            [class.bg-blue-38]="currentItem.ParentTicketID == null"
            [class.bg-yellow]="currentItem.ParentTicketID != null" (click)="doOpenMergeModal()">
            <span class="m-0 p-0">{{ currentItem.ParentTicketID == null ? "Merge" : "Unmerge" }}</span>
          </div> -->
          @if(currentItem.ParentTicketID == null) {
          <div class="d-inline ticket-view-btn bg-blue-38 text-center ml-3" (click)="doOpenMergeModal()">
            <span class="m-0 p-0">Merge</span>
          </div>
          }
          @if(currentItem.ParentTicketID != null){
          <div class="d-inline ticket-view-btn bg-yellow text-center ml-3" style="width: fit-content; white-space: nowrap;" (click)="doOpenUnmergeModal()">
            <span class="m-0 p-0">Unmerge</span>
          </div>
          }
          <div class="d-inline ticket-view-btn bg-blue-38 text-center" (click)="doSetPinned()">
            <span class="m-0 p-0">{{ currentItem.IsPinnedByUser == true? "Unpin" : "Pin" }}</span>
          </div>
          @if(currentItem.GitHub_IssueNumber == null || currentItem.GitHub_IssueNumber == 0) {
          <div class="d-inline ticket-view-btn bg-blue-38 text-center" (click)="showLinkGitHub()">
            <span class="m-0 p-0">Send&nbsp;To&nbsp;Github</span>
          </div>
          }
          @if(currentItem.GitHub_IssueNumber != null && currentItem.GitHub_IssueNumber != 0){
          <div class="d-inline ticket-view-btn bg-blue-38 text-center" style="width: fit-content; white-space: nowrap;" (click)="openGitHubLink()">
            <span class="m-0 p-0">Open in Github</span>
          </div>
          }
          @if(currentItem.DateClosed == null){
          <div class="d-inline  ticket-view-close-btn bg-red text-center" (click)="doSetClosed()">
            <span class="m-0 p-0">Close</span>
          </div>
          }
          @if(currentItem.DateClosed != null){
          <div class="d-inline ticket-view-restore-btn bg-lightgreen text-center" (click)="doSetClosed()">
            <span class="m-0 p-0">Restore</span>
          </div>
          }
        </div>
        <h2 class="content-heading-font pr-3">
          #{{ currentItem.ID }} - {{currentItem.Subject }}
        </h2>
      </div>
      <div class="col-12 m-0 pr-3 font-22 align-content-end">
        <div class="mr-0 pr-0 float-content-center" *ngIf="currentItem.DateClosed != null">
          <div class="bg-red round-15 pl-2 pr-2 m-0">
            <span class="m-0 p-0 txt-red">Closed: </span>
            <span class="m-0 p-0 txt-red">{{ currentItem.DateClosed | date: 'short' }}</span>
          </div>
        </div>
        <div class="col-6 col-sm-12 m-0 pr-3 font-22 align-content-end">

        </div>
      </div>
    </div>
  </div>
  <div class="main-page-content-block mt-3 p-1" *ngIf="currentItem && ((currentItem.Files != null && currentItem.Files.length > 0) || (currentItem.RelatedTickets != null && currentItem.RelatedTickets.length > 0))">
    <div class="font-22 float-content-center ml-3 pl-1 w-100">
      <div class="ticket-file-thumbnail bg-white-hover m-1 p-2" role="button" *ngFor="let file of currentItem.Files" (click)="doShowAttachment(file)">
        <div *ngIf="isImageAttachment(file)">
          <img class="ticket-img-thumbnail" [src]="getAttachmentThumbnail(file)" />
        </div>
        <div *ngIf="!isImageAttachment(file)" class="ticket-file-icon-container float-content-center">
          <i class="fa fa-file ticket-file-icon"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3" *ngIf="currentItem">
    <div class=" col-12 col-lg-5 col-xl-4 col-xxl-3 p-0 ticket-col-left">
      <div class="row g-0 ">
        <div class="col-12 col-sm-6 col-lg-12">
          <div class="row main-page-content-block-secondary font-18 mb-3"
               *ngIf="currentItem && currentItem.RelatedTickets != null && currentItem.RelatedTickets.length > 0">
            <div class="col-12">
              <div class="row float-content-center">
                <div class="col-12 float-content-start text-nowrap">
                  <span class="">Related Tickets</span>
                </div>
                <div class="col-12 pr-2 pt-2 align-content-end">
                  <p-dropdown [options]="currentItem.RelatedTickets" class="form-control w-100 ticket-assignee-multiselect ml-2"
                              placeholder="Select" [(ngModel)]="ticketIDToOpen" (onChange)="openTicket($event)" optionLabel="Label" optionValue="Value"></p-dropdown>
                </div>
                <div class="col-12 p-0 m-0">
                  <div class="row mh-200">
                    <div class="col-12 m-0 pt-2 pb-2 float-content-center" *ngFor="let related of currentItem.RelatedTickets">
                      <span class="font-bold">{{ related.Label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-12  main-page-content-block-secondary font-18 mb-3">
          <table>
            <tr>
              <td class="p-1 text-nowrap">GitHub Issue:</td>
              <td class="p-1 font-bold">
                <a [href]="gitHubLink"
                   class="font-bold" target="_blank">#{{ currentItem.GitHub_IssueNumber  }}</a>
              </td>
            </tr>
            <tr>
              <td class="p-1">Issue Type:</td>
              <td class="p-1 font-bold"> {{ currentItem.GitHub_Type }}</td>
            </tr>
            <tr>
              <td class="p-1">Labels:</td>
              <td class="p-1 font-bold">
                <span *ngFor="let label of currentItem.GitHub_Labels" [class]="getGitLabelClass(label)"
                      [style.background-color]="'#' + label.Color" title="{{label.Description}}">{{label.Name}}</span>
              </td>
            </tr>
            <tr>
              <td class="p-1">Status:</td>
              <td class="p-1 font-bold">{{ currentItem.DisplayStatus}}</td>
            </tr>
            <tr>
              <td class="p-1">GitHub Status:</td>
              <td class="p-1 font-bold">{{ currentItem.GitHub_Status}}</td>
            </tr>
            <tr>
              <td class="p-1">Assignees:</td>
              <td class="p-1 font-bold">
                <div *ngFor="let user of currentItem.GitHub_Users" class="mr-1 mb-1 d-inline-block round-10 bg-blue float-content-center pr-2">
                  <img *ngIf="user.AvatarUrl != null && user.AvatarUrl != ''" [src]="user.AvatarUrl" class="github-user-avatar d-inline-block m-1" />
                  <i *ngIf="user.AvatarUrl == null || user.AvatarUrl == ''" class="fa fa-user-circle p-0 m-1"></i>
                  <span class="ml-1" style="font-size: 14px;">{{user.Login}}</span>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-12 col-sm-6 col-lg-12">
          <div class="main-page-content-block mb-3 font-18 ">
            <table>
              <tr>
                <td class="p-1">Client:</td>
                <td class="p-1 font-bold"> {{ currentItem.Client }}</td>
              </tr>
              <tr>
                <td class="p-1">Submitter:</td>
                <td class="p-1 font-bold"> {{ currentItem.Client_Name }}</td>
              </tr>
              <tr>
                <td class="p-1">Opened:</td>
                <td class="p-1 font-bold">{{ currentItem.DateCreated | date: 'short' }}</td>
              </tr>
              <tr>
                <td class="p-1">Updated:</td>
                <td class="p-1 font-bold">{{ currentItem.LastUpdated | date: 'short' }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-12">
          <div class="row main-page-content-block font-18 mb-3">
            <div class=" col-12">
              <div class="row round-10 bg-white mb-2">
                <div class="col-4 align-content-start">
                  <label for="ticket-type-select">Type</label>
                </div>
                <div class="col-8 align-content-end pr-0" *ngIf="types != null">
                  <p-dropdown [options]="types" class="form-control form-control-sm"
                              [(ngModel)]="currentItem.SupportTicketTypeID" placeholder="Select" (ngModelChange)="doChangeType()" optionLabel="Label" optionValue="Value"></p-dropdown>
                </div>
                <div class="col-8 align-content-end" *ngIf="types == null">
                  <span>{{ currentItem.SupportTicketType }}</span>
                </div>
              </div>
              <div class="row round-10 bg-white mb-2">
                <div class="col-4 align-content-start">
                  <span>Assigned:</span>
                </div>
                <div class="col-8 align-content-end pr-0">
                  <p-multiSelect [options]="assigneeOptions ?? []"
                                 class="w-full form-control ticket-assignee-multiselect"
                                 [(ngModel)]="currentItem.AssignedToUserID"
                                 (ngModelChange)="doSetAssigned()"
                                 placeholder="None"
                                 optionLabel="Label"
                                 optionValue="Value">

                  </p-multiSelect>
                </div>
              </div>
              <div class="row round-10 bg-white mt-2">
                <div class="col-4 align-content-start">
                  <label for="ticket-priority-select">Priority</label>
                </div>
                <div class="col-8 align-content-end pr-0" *ngIf="priorities != null">
                  <p-dropdown [options]="priorities" class="form-control  form-control-sm"
                              [(ngModel)]="currentItem.SupportTicketPriorityID" placeholder="Select" (ngModelChange)="doChangePriority()" optionLabel="Label" optionValue="Value"></p-dropdown>
                </div>
                <div class="col-8 align-content-end" *ngIf="priorities == null">
                  <span>{{ currentItem.SupportTicketPriority }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-12">
          <div class=" main-page-content-block font-18 mb-3"
               *ngIf="currentItem
           && (currentItem.SystemUrl != null
           || currentItem.ErrorMessage != null
           || currentItem.OtherDetails != null ) ">
            <div *ngIf="currentItem.SystemUrl" class="p-2 text-truncate ">
              <span class="mr-2">URL:</span>
              <a [href]="currentItem.SystemUrl" target="_blank">{{ currentItem.SystemUrl }}</a>
            </div>
            <div *ngIf="currentItem.ErrorMessage" class="p-2  ">
              <span class="mr-2">Error Message:</span>
              <span style="line-break: anywhere">{{ currentItem.ErrorMessage }}</span>
            </div>
            <div class="p-2" *ngFor="let otherItem of getOtherDetails()">
              <span class="mr-2">{{ otherItem.label }}:</span> <span style="line-break: anywhere">{{ otherItem.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-7 col-xl-8 col-xxl-9 ticket-col-right mt-2 main-page-content-block">
      <div #messageContainer class="row mt-2 p-2 font-16 messages-container">
        <div class="col-12 m-0 p-2" #messageRow *ngFor="let message of currentItem.Messages">
          <div class="row w-100"
               [class.float-content-end]="message.IsMyMessage"
               [class.float-content-start]="!message.IsMyMessage">
            <div class="ticket-message-container col-10 pt-0 pb-2 m-0 pl-1 pr-1"
                 [class.bg-blue-38]="!message.IsAdmin && !message.AdminViewOnly"
                 [class.bg-blue]="message.IsAdmin && !message.AdminViewOnly && !message.IsMyMessage"
                 [class.bg-lightgreen]="message.IsAdmin && !message.AdminViewOnly && message.IsMyMessage"
                 [class.bg-lightpurple]="message.AdminViewOnly">
              <div class="row w-100">
                <div class="col-12 float-content-end" *ngIf="message.IsMyMessage == true">
                  <div class="message-options-button m-0 bg-lightblue" (click)="showMessageMenu(message)">
                    <i class="fa fa-pencil-square-o m-0 p-2"></i>
                  </div>
                  <div class="message-menu-container round-15 bg-lightblue" *ngIf="selectedMessageID == message.ID">
                    <div class="float-content-start mb-1">
                      <p-checkbox type="checkbox"
                                  class=""
                                  name="closed"
                                  [binary]="true"
                                  [(ngModel)]="message.AdminViewOnly" (ngModelChange)="changeMessageAdminView(message)" id="ticket-closed-filter"></p-checkbox>
                      <label for="ticket-closed-filter" class="ml-1 font-14">Admin View Only</label>
                    </div>
                    <div class="message-menu-button mb-1" (click)="showEditMessage(message)">
                      Edit
                    </div>
                    <div class="message-menu-button bg-red" (click)="deleteMessage(message.ID)">
                      Delete
                    </div>
                  </div>
                </div>
                <div class="col-12 mt-2 pt-2">
                  <div class="row">
                    <div class="col-md-6 col-sm-12 m-0 p-0 mr-1 float-content-start">
                      <span class="m-0 p-0">{{ message.User }}</span>
                    </div>
                    <div class="col-md-6 col-sm-12 m-0 p-0 float-content-dynamic-end">
                      <span class="">{{ message.DateCreated | date:'medium' }}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="ticket-file-thumbnail bg-white-hover m-1 p-2 col" role="button" *ngFor="let file of message.Attachments; let i = index" (click)="doShowAttachment(file)">
                    <div *ngIf="isImageAttachment(file)">
                      <img class="ticket-img-thumbnail" [src]="getAttachmentThumbnail(file)" />
                    </div>
                    <div *ngIf="!isImageAttachment(file)" class="ticket-file-icon-container float-content-center">
                      <i class="fa fa-file ticket-file-icon"></i>
                    </div>
                  </div>
                </div>

                <div class="col-12 mt-1 pl-3 pb-2 pt-2 bg-lightblue ticket-message" *ngIf="message.MessageHtml != null && message.ID == editingMessageID && doEdit == true">
                  <div class="row">
                    <ckeditor #editMessageEditor
                              id="editMessage"
                              name="newMessage"
                              [editor]="Editor"
                              [data]="message.MessageHtml"
                              [config]="editorConfig"
                              (change)="editMessageChange($event)"></ckeditor>
                  </div>
                  <div class="row">
                    <div class="col-12 m-0 p-0 float-content-end">
                      <div class="ticket-view-btn bg-white-hover text-center" (click)="cancelEdit(message)">
                        <span class="m-0 p-0">Cancel</span>
                      </div>
                      <div class="ticket-view-btn bg-blue-38 text-center" (click)="doEditMessage(message)">
                        <span class="m-0 p-0">Update</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 mt-1 pl-3 pb-2 pt-2 bg-lightblue ticket-message" *ngIf="message.MessageHtml == null && message.Message != null && message.ID == editingMessageID && doEdit == true">
                  <div class="row">
                    <ckeditor #editMessageEditor
                              id="editMessage"
                              name="newMessage"
                              [editor]="Editor"
                              [data]="message.Message"
                              [config]="editorConfig"
                              (change)="editMessageChange($event)"></ckeditor>
                  </div>
                  <div class="row">
                    <div class="col-12 m-0 p-0 float-content-end">
                      <div class="ticket-view-btn bg-blue-38 text-center" (click)="doEditMessage(message)">
                        <span class="m-0 p-0">Update</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 mt-1 pl-3 pb-2 pt-2 bg-lightblue ticket-message" *ngIf="(doEdit == false || editingMessageID != message.ID) && message.MessageHtml == null && editingMessageID != message.ID">
                  <div class="w-100">
                    <span class="m-0 p-0">{{ message.Message }}</span>
                  </div>
                </div>
                <div class="col-12 mt-1 pl-3 pb-0 pt-2 bg-lightblue ticket-message" *ngIf="(doEdit == false || editingMessageID != message.ID) && message.MessageHtml != null">
                  <div class="w-100" [innerHTML]="message.MessageHtml">
                  </div>
                </div>
                <div class="col-12 text-end pt-1" *ngIf="message.AdminViewOnly">(Admin View Only)</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 new-message-container sticky-bottom">
          <div class="row w-100 mb-2 mt-3">
            <div class="col-12">
              <ckeditor #newMessageEditor
                        id="newMessage"
                        name="newMessage"
                        [editor]="Editor"
                        [data]="initialNewMessage"
                        [config]="editorConfig"
                        (change)="editorOnChange($event)"></ckeditor>
            </div>
            <div class="col-8 float-content-start mt-3">
              <div class="mb-1 ml-1 float-content-start">
                <p-checkbox type="checkbox"
                            class=""
                            name="isAdminViewOnly"
                            [binary]="true"
                            [(ngModel)]="adminViewOnly" id="isAdminViewOnly"></p-checkbox>
                <label for="isAdminViewOnly" class="ml-1 font-18">Admin View Only</label>
              </div>
            </div>
            <div class="col-4 float-content-end mt-3">
              <div class="message-btn bg-blue-38 text-center" (click)="sendNewMessage()">
                <span class="m-0 p-0 font-22">Send</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="mb-3" #messageRow *ngFor="let message of currentItem.Messages">
      <div class="ticket-message-container mb-2 "
           [class.bg-blue-38]="!message.IsAdmin && !message.AdminViewOnly"
           [class.bg-blue]="message.IsAdmin && !message.AdminViewOnly"
           [class.bg-lightpurple]="message.AdminViewOnly">
        <div class="row">
          <div class="col-12 pt-2">
            <div class="float-right">
              <span class="text-danger mr-2" *ngIf="message.AdminViewOnly">(Admin View Only)</span>
              <a href="javascript:void()" class="text-danger mr-2" *ngIf="!message.DateRead && !message.IsAdmin"
                 (click)="doSetMessageRead(message)">
                <i class="fa fa-exclamation" title="Unread"></i>
              </a>
              <span class="">{{ message.DateCreated | date:'medium' }}</span>
              <div class="d-inline" *ngIf="message.IsMyMessage == true">
                <div class="message-options-button m-0" (click)="showMessageMenu(message)">
                  <i class="fa fa-pencil-square-o m-0 p-2"></i>
                </div>
                <div class="message-menu-container round-15" *ngIf="selectedMessage == message">
                  <div class="align-content-start mb-1">
                    <p-checkbox type="checkbox"
                                class=""
                                name="closed"
                                [binary]="true"
                                [(ngModel)]="message.AdminViewOnly" (ngModelChange)="changeMessageAdminView(message)" id="ticket-closed-filter"></p-checkbox>
                    <label for="ticket-closed-filter" class="ml-1 font-14">Admin View Only</label>
                  </div>
                  <div class="message-menu-button mb-1" (click)="showEditMessage(message)">
                    Edit
                  </div>
                  <div class="message-menu-button bg-red" (click)="deleteMessage(message.ID)">
                    Delete
                  </div>
                </div>
              </div>
            </div>
            <span class="m-0 p-0">{{ message.User }}</span>
          </div>
          <div class="row">
            <div class="ticket-file-thumbnail bg-white-hover m-1 p-2 " role="button" *ngFor="let file of message.Attachments" (click)="doShowAttachment(file)">
              <div *ngIf="isImageAttachment(file)">
                <img class="ticket-img-thumbnail" [src]="getAttachmentThumbnail(file)" />
              </div>
              <div *ngIf="!isImageAttachment(file)" class="ticket-file-icon-container float-content-center">
                <i class="fa fa-file ticket-file-icon"></i><br />
                <span>{{ file.FileName }}</span>
              </div>
            </div>
          </div>

          <div class="col-12 mt-1 pl-3 pb-2 pt-2 bg-lightblue ticket-message" *ngIf="message.MessageHtml != null && selectedMessage == message && doEdit == true">
            <div class="row">
              <ckeditor #editMessageEditor
                        id="editMessage"
                        name="newMessage"
                        [editor]="Editor"
                        [data]="message.MessageHtml"
                        [config]="editorConfig"
                        (change)="editMessageChange($event)"></ckeditor>
            </div>
            <div class="row">
              <div class="col-12 m-0 p-0 align-content-end">
                <div class="ticket-view-btn bg-white-hover text-center" (click)="cancelEdit(message)">
                  <span class="m-0 p-0">Cancel</span>
                </div>
                <div class="ticket-view-btn bg-blue-38 text-center" (click)="doEditMessage(message)">
                  <span class="m-0 p-0">Update</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mt-1 pl-3 pb-2 pt-2 bg-lightblue ticket-message" *ngIf="message.MessageHtml == null && message.Message != null && selectedMessage == message && doEdit == true">
            <div class="row">
              <ckeditor #editMessageEditor
                        id="editMessage"
                        name="newMessage"
                        [editor]="Editor"
                        [data]="message.Message"
                        [config]="editorConfig"
                        (change)="editMessageChange($event)"></ckeditor>
            </div>
            <div class="row">
              <div class="col-12 m-0 p-0 align-content-end">
                <div class="ticket-view-btn bg-blue-38 text-center" (click)="doEditMessage(message)">
                  <span class="m-0 p-0">Update</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mt-1 pl-3 pb-2 pt-2 bg-lightblue ticket-message" *ngIf="message.MessageHtml == null && (selectedMessage != message && doEdit != true)">
            <div class="w-100">
              <span class="m-0 p-0">{{ message.Message }}</span>
            </div>
          </div>
          <div class="col-12 mt-1 pl-3 pb-0 pt-2 bg-lightblue ticket-message" *ngIf="message.MessageHtml != null && (selectedMessage != message && doEdit != true)">
            <div class="w-100" [innerHTML]="message.MessageHtml">
            </div>
          </div>
        </div> -->
  </div>
</div>

<p-dialog header="Support Ticket File" [modal]="true" [(visible)]="attachmentModalVisible" [style]="{ width: 'fit-content', 'max-width': '90vw' }">
  <div class="row">
    <div class="col mb-3">
      <div *ngIf="modalIsImageAttachment() && loadingAttachment" class="float-right button-loading font-22">&nbsp;</div>
      <h5 class="content-heading-font">{{ selectedAttachmentName }}</h5>
    </div>
  </div>
  <div class="row main-page-content-block float-content-center border">
    <div *ngIf="modalIsImageAttachment()">
      <a [href]="getModalAttachmentImage()" target="_blank">
        <img [src]="getModalAttachmentImage()" class="ticket-img-lg" />
      </a>
    </div>
    <div *ngIf="!modalIsImageAttachment() && selectedFile" class="ticket-file-icon-container float-content-center" (click)="doDownloadAttachment()">
      <i class="fa fa-file font-22 mr-3"></i>
      <span>{{selectedFile.FileSize }}Kb</span>
      <button class="btn" role="button">
        <i class="fa fa-cloud-download"></i>
      </button>
    </div>
  </div>
  <div class="row mt-3 pt-2">
    <div class="col text-center">
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnAttachmentClose" (click)="attachmentModalVisible=false">Cancel</button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Merge Ticket" [modal]="true" [(visible)]="mergeModalVisible" [style]="{'min-width': '70vw'}">
  <div class="row pos-relative" *ngIf="currentItem != null">
    <div class="col-12">
      <h5 class="content-heading-font mb-3">{{ "Current Ticket Subject:   " + currentItem.Subject }}</h5>
    </div>
    <div class="col-12 mb-3 font-22">
      <div class="row float-content-center" style="width: 90%">
        <div class="col-2">
          <label for="similiar-ticket-search" class="font-20 mr-3">Search: </label>
        </div>
        <div class="col-10">
          <input type="text" class="form-control" [(ngModel)]="similiarSearchString" (ngModelChange)="filterSimiliarTickets()" />
        </div>
      </div>
    </div>
    <div class="col-12 mb-3">
      <span class="m-0 p-0 font-14">Select the parent ticket for this ticket</span>
    </div>
    <div class="col-12 mb-3 float-content-center font-22" [style]="{'min-width': '65vw'}">
      <div class="row">
        <div class="col-12 left-menu-ticket p-3 mt-1 mb-1" *ngFor="let ticket of similiarTickets; let i = index" (click)="selectSimiliarTicket(ticket)">
          <div class="row">
            <div class="col-1 float-content-center">
              <p-checkbox type="checkbox"
                          class=""
                          name="selected"
                          [binary]="true"
                          [(ngModel)]="ticket.Selected" (ngModelChange)="selectSimiliarTicket(ticket)" id="similiar-ticket-selected"></p-checkbox>
            </div>
            <div class="col-10">
              <div class="row mb-2 font-bold font-22">
                <div class="col-6 p-0 m-0 align-content-start">
                  <p class="ml-1 mb-0">{{ "#" + ticket.ID}}</p>
                </div>
                <div class="col-6 p-0 m-0 align-content-end">
                  <p class="mr-1 mb-0">{{ ticket.CreatedDate | date:'short' }}</p>
                </div>
              </div>
              <div class="row font-16">
                <div class="col-6 float-content-between bg-blue round-10">
                  <p class="pl-0 ml-0">Subject: </p>
                  <p class="pl-0 ml-2">{{ ticket.Subject }}</p>
                </div>
                <div class="col-6 float-content-between round-10">
                  <p class="pl-0 ml-0">Problem: </p>
                  <p class="pl-0 ml-2">{{ ticket.Problem }}</p>
                </div>
                <div class="col-6 float-content-between round-10">
                  <p class="pl-0 ml-0">ErrorMessage: </p>
                  <p class="pl-0 ml-2">{{ ticket.ErrorMessage }}</p>
                </div>
                <div class="col-6 float-content-between round-10 bg-blue">
                  <p class="pl-0 ml-0">URL: </p>
                  <p class="pl-0 ml-2">{{ ticket.URL }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 p-3 text-center sticky-bottom align-content-end bg-white round-15">
    <button class="btn btn-lg btn-primary ms-2" type="button" id="btnMergeClose" (click)="doMergeToParentTicket()">Merge To Parent</button>
    <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnMergeClose" (click)="mergeModalVisible=false">Cancel</button>
  </div>
</p-dialog>

<p-dialog header="Link GitHub Issue" [modal]="true" [(visible)]="gitHubIssueVisible">
  <div class="row">
    <div class="col mb-3">
      <label for="gitHubIssue">Issue</label><br />
      <select id="gitHubIssue" [(ngModel)]="gitHubIssue" [class.div-loading]="loadingGitHubIssue" class="form-control">
        <option *ngFor="let issue of gitHubIssues" [ngValue]="issue">
          {{issue.repository}} -  {{issue.number}} -  {{issue.title}}
        </option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col mb-3">
      <label for="gitHubComment">Comment</label><br />
      <input type="text" id="gitHubComment" [(ngModel)]="gitHubComment" class="form-control" />
    </div>
  </div>
  <div class="row">
    <div class="col text-center">
      <button class="btn btn-lg btn-primary" type="submit" id="btnGithubConfirm" [class.button-loading]="loading" (click)="linkGitHub()">Confirm</button>
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnGithubCancel" [class.button-loading]="loading" (click)="gitHubIssueVisible=false">Cancel</button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Unmerge Ticket" [modal]="true" [(visible)]="UnmergeModalVisible" [style]="{'min-width': '70vw'}">
  @if(currentItem?.ParentTicketID != null) {
  <div class="row mb-3 float-content-center">
    <div class="col-12 float-content-center">
      <span class="font-22 m-0 p-2">
        This ticket is currently merged under parent ticket #{{currentItem?.ParentTicketID}}.
        Unmerging will make this ticket a standalone ticket again.
      </span>
    </div>
    <div class="col-12 mt-3 float-content-center">
      <span class="font-20 m-0 p-2">Would you like to unmerge all tickets merged under parent ticket #{{currentItem?.ParentTicketID}}?</span>
    </div>
    <div class="col-6 float-content-center p-2 m-2 round-10 border" role="button" [class.bg-blue-38]="unmergeAllRelatedTickets==true" (click)="unmergeAllRelatedTickets=true">
      <span class="font-16 m-0 p-2">Yes</span>
    </div>
    <div class="col-6 float-content-center p-2 m-2 round-10 border" role="button" [class.bg-blue-38]="unmergeAllRelatedTickets==false" (click)="unmergeAllRelatedTickets=false">
      <span class="font-16 m-0 p-2">No</span>
    </div>
  </div>
  }
  @else{
  <div class="row">
    <div class="col mb-3">
      <span class="font-22 m-0 p-2">Select which tickets you would like to unmerge this ticket from:</span>
    </div>
  </div>
  <div class="row mb-3 float-content-center">
    <div class="col-10 float-content-center p-2 m-2 round-10 border" role="button" [class.bg-blue-38]="unMergeAllChildrenTickets==true" (click)="selectAllRelatedTickets()">
      <span class="font-16 m-0 p-2">Unmerge All Tickets</span>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12" *ngFor="let ticket of SelectedRelatedTickets">
      <div class="w-100 p-2 round-15" role="button" [class.bg-lightblue]="ticket.Selected" (click)="ticket.Selected = !ticket.Selected">
        <i class="fa fa-check mr-2" *ngIf="ticket.Selected"></i>
        <span class="font-16 p-2">{{ticket.Subject}}</span>
      </div>
    </div>
  </div>
  }
  <div class="row border-top pt-2 mt-2">
    <div class="col text-center">
      <button class="btn btn-lg btn-primary" type="submit" [class.button-loading]="loading" (click)="doUnmergeTickets()">Unmerge</button>
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnGithubCancel" [class.button-loading]="loading" (click)="doCloseUnmergeModal()">Cancel</button>
    </div>
  </div>
</p-dialog>


